import { apiDelete, apiGet, apiPost } from '@/lib/api';

export const NOTE_EVENTS = {
  context: 'gv:chat-context',   // detail: { sessionId, subject, chapter } | null
  saved: 'gv:note-saved',       // detail: { notes }
};

export const captureNote = (body) => apiPost('/notes/capture', body);
export const deleteNote = (id) => apiDelete(`/notes/${id}`);
export const fetchTonight = () => apiGet('/notes/tonight');
export const markTonightDone = () => apiPost('/notes/tonight/done', {});

export function fetchNotes({ subject, chapter, sessionId, today } = {}) {
  const q = new URLSearchParams();
  if (subject) q.set('subject', subject);
  if (chapter) q.set('chapter', chapter);
  if (sessionId) q.set('session_id', sessionId);
  if (today) q.set('today', 'true');
  const qs = q.toString();
  return apiGet(`/notes${qs ? `?${qs}` : ''}`);
}

export const announceNoteSaved = (notes) =>
  window.dispatchEvent(new CustomEvent(NOTE_EVENTS.saved, { detail: { notes } }));
